<template lang="pug">
AppDialog#reschedule-jobs-dialog(
  show
  size="smedium"
  has-footer
  append-to-body
  title="Re-schedule jobs"
  @close="$emit('cancel')"
)
  p This work order has jobs that were scheduled for the future. Do you want to re-schedule them to your calendar, or remove them from this work order?

  template(slot="footer")
    AppButton.mr-15(
      type="danger"
      @click="$emit('cancel')"
    ) Remove jobs
    AppButton(
      type="primary"
      @click="$emit('confirm')"
    ) Re-schedule jobs
</template>

<script>
export default {
  name: 'WorkOrdersRescheduleJobsDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
